var map = {
	"./address_image.svg": 599,
	"./animated_ashutosh.png": 7875,
	"./animated_logo.svg": 7733,
	"./blogs_image.svg": 2885,
	"./cloud_infrastructure.svg": 7957,
	"./codeInLogo.png": 7935,
	"./contactMail.png": 9581,
	"./coursera_logo.png": 1877,
	"./data_science.svg": 8938,
	"./deeplearning_ai_logo.png": 2862,
	"./delhivery_logo.png": 4625,
	"./developerActivity.svg": 6715,
	"./dsc_logo.png": 6390,
	"./education.svg": 855,
	"./experience.svg": 9917,
	"./fac_logo.png": 3832,
	"./feelingProud.svg": 658,
	"./freecopy_logo.png": 9273,
	"./fullstack.svg": 2043,
	"./gcp_logo.png": 1513,
	"./github_logo.png": 9551,
	"./googleAssistant.jpg": 700,
	"./googleAssistant.svg": 3564,
	"./google_logo.png": 5927,
	"./ibm_logo.png": 9561,
	"./iiitk_logo.png": 5241,
	"./intel_logo.jpg": 3026,
	"./iu_logo.png": 1576,
	"./jsFramework.svg": 8446,
	"./legato_logo.png": 5112,
	"./manOnTable.svg": 3034,
	"./microsoft_logo.png": 7231,
	"./mozilla_logo.png": 9592,
	"./muffito_logo.png": 2295,
	"./nextuLogo.jpg": 1631,
	"./nptel_logo.png": 8936,
	"./ovi2023.png": 1798,
	"./portfolio.gif": 3549,
	"./programmer.svg": 9220,
	"./projects_image.svg": 4716,
	"./pwa.png": 7758,
	"./saayaHealthLogo.png": 6006,
	"./stanford_logo.png": 7137,
	"./talksCardBack.svg": 5331,
	"./talksCardBackAlt.svg": 7945,
	"./tiger_book.jpg": 6893,
	"./tiger_glasses.webp": 1130,
	"./tiger_laptop_512.jpg": 6974,
	"./tiger_proiecte.jpg": 8257,
	"./tiger_project.jpg": 743,
	"./tiktok_logo.png": 2032,
	"./ui_ux_design.svg": 2337,
	"./unstpb_logo.png": 5242
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1106;